import React from 'react'
import Axios from 'axios'
import Availabilities from '../Availabilities'
import PhotoUpload from '../AddTeacherModal/PhotoUpload/PhotoUpload'
import './admin-teacher-modal.css'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import AreYouSureDeleteTeacherModal from './AreYouSureDeleteTeacherModal/AreYouSureDeleteTeacherModal'
import EditTeacherAvailabilityPopup from './EditTeacherAvailabilityPopup/EditTeacherAvailabilityPopup'
import AddInstrumentPopup from '../AddTeacherModal/AddInstrumentsPopup/AddInstrumentsPopup'
import AddTownsPopup from '../AddTeacherModal/AddTownsPopup/AddTownsPopup'

const AdminTeacherModal = (props) => {
    const [photoChange, setPhotoChange] = React.useState(false)
    const [imageName, setImageName] = React.useState('')
    const [changes, setChanges] = React.useState(false)
    const [name, setName] = React.useState(props.teacher.Name)
    const [instruments, setInstruments] = React.useState(props.teacher.Instrument)
    const [calendarId, setCalendarId] = React.useState(props.teacher.CalendarID)
    const [email, setEmail] = React.useState(props.teacher.Email)
    const [phone, setPhone] = React.useState(props.teacher.PhoneNumber)
    const [street, setStreet] = React.useState(props.teacher.Address.StreetAddress)
    const [city, setCity] = React.useState(props.teacher.Address.City)
    const [state, setAddressState] = React.useState(props.teacher.Address.State)
    const [zip, setZip] = React.useState(props.teacher.Address.Zip)
    const [bio, setBio] = React.useState(props.teacher.Bio)
    const [rate, setRate] = React.useState(props.teacher.Rate)
    const [teachAvail, setTeachAvail] = React.useState(props.teacher.AvailabilityDetails)
    const [teacherStatus, setTeacherStatus] = React.useState('')
    const [adminNotes, setAdminNotes] = React.useState('')
    const [bkgd, setBkgd] = React.useState(props.teacher.BackgroundCheck)
    const [verifiedColor, setVerifiedColor] = React.useState('rgb(182, 118, 0)')
    const [activeStudents, setActiveStudents] = React.useState(0)
    const [facebook, setFacebook] = React.useState('')
    const [twitter, setTwitter] = React.useState('')
    const [instagram, setInstagram] = React.useState('')
    const [youtube, setYoutube] = React.useState('')
    const [linkedin, setLinkedin] = React.useState('')
    const [pinterest, setPinterest] = React.useState('')
    const [soundcloud, setSoundcloud] = React.useState('')
    const [tumblr, setTumblr] = React.useState('')
    const [tiktok, setTiktok] = React.useState('')
    const [personalWebsite, setPersonalWebsite] = React.useState('')
    const [deleteModal, setDeleteModal] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [wantsMore, setWantsMore] = React.useState(props.teacher.WantsMoreStudents)
    const [editTeacherAvailability, setEditTeacherAvailability] = React.useState(false)
    const [instPopup, setInstPopup] = React.useState(false)
    const [townsPopup, setTownsPopup] = React.useState(false)
    const [listOfInstruments, setListOfInstruments] = React.useState([])
    const [listOfTowns, setListOfTowns] = React.useState([])
    const [listOfCancellations, setListOfCancellations] = React.useState([])
    const [listOfTimesheets, setListOfTimesheets] = React.useState([])
    const [tab, setTab] = React.useState('profile')
    const [onboardDate, setOnboardDate] = React.useState('')
    const [departureDate, setDepartureDate] = React.useState('')
    const [calendarColor, setCalendarColor] = React.useState({})

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        if(props.teacher) {
            getTeachersCancellations()
        }
        if(props.teacher.AdminNotes) {
            setAdminNotes(props.teacher.AdminNotes)
        }
        if(props.teacher.InstrumentList) {
            setListOfInstruments(props.teacher.InstrumentList)
        }
        if(props.teacher.ImageName) {
            setImageName(props.teacher.ImageName)  
        }
        if(props.teacher.TownList) {
            setListOfTowns(props.teacher.TownList)
        }
        if(props.teacher.SocialLinks) {
            setFacebook(props.teacher.SocialLinks.Facebook)
            setTwitter(props.teacher.SocialLinks.Twitter)
            setInstagram(props.teacher.SocialLinks.Instagram)
            setYoutube(props.teacher.SocialLinks.Youtube)
            setLinkedin(props.teacher.SocialLinks.Linkedin)
            setPinterest(props.teacher.SocialLinks.Pinterest)
            setSoundcloud(props.teacher.SocialLinks.Soundcloud)
            setTumblr(props.teacher.SocialLinks.Tumblr)
            setTiktok(props.teacher.SocialLinks.Tiktok)
            setPersonalWebsite(props.teacher.SocialLinks.Website)
        }
        if(props.teacher.OnboardDate) {
            setOnboardDate(props.teacher.OnboardDate)
        }
        if(props.teacher.DepartureDate) {
            setDepartureDate(props.teacher.DepartureDate)
        }
        if(props.teacher.CalendarColor) {
            setCalendarColor(props.teacher.CalendarColor)
        }
        if(props.teacher.BackgroundCheck === 'verified') {
            setBkgd('verified')
            setVerifiedColor('green')
        } else if (props.teacher.BackgroundCheck === 'pending') {
            setBkgd('pending')
            setVerifiedColor('rgb(182, 118, 0)')
        } else if (props.teacher.BackgroundCheck === 'ordered'){
            setBkgd('ordered')
            setVerifiedColor('rgb(182, 118, 0)')
        } else {
            setBkgd('pending')
            setVerifiedColor('rgb(182, 118, 0)')
        }
        setActiveStudents(tallyActiveStudents())
        if(props.teacher.Status) {
            setTeacherStatus(props.teacher.Status)
        } else {
            setTeacherStatus('Active')
        }
        openingAnimation()
    }, [])
    React.useEffect(() => {
        document.getElementById('the-verfied-selector').value = bkgd
        if(bkgd === 'verified') {
            setVerifiedColor('green')
        } else {
            setVerifiedColor('rgb(182, 118, 0)')
        }
    }, [bkgd])
    React.useEffect(() => {
        if(instPopup) {
            setChanges(true)
        }
        if(townsPopup) {
            setChanges(true)
        }
    }, [instPopup, townsPopup])

    const openingAnimation = () => {
        document.getElementById('admin-teacher-modal').style.left = "50px"
        document.getElementById('admin-teacher-modal').style.opacity = 1
        document.getElementById("admin-teacher-modal-wrapper").style.opacity = 1
    }

    const closingAnimation = () => {
        document.getElementById('admin-teacher-modal').style.left = "-1000px"
        document.getElementById('admin-teacher-modal').style.opacity = 0 
        document.getElementById("admin-teacher-modal-wrapper").style.opacity = 0
    }

    const getTeachersCancellations = () => {
        Axios.get(`${baseUrl}/oldtimesheets/${props.teacher.TeacherID}`, myHeader)
        .then((res) => {
            setListOfTimesheets(res.data)
            let list = []
            for(let i = 0; i < res.data.length; i++) {
                let cancellationTotal = 0
                for(let j = 0; j < res.data[i].families.length; j++) {
                    for(let k = 0; k < res.data[i].families[j].cancellations.length; k++) {
                        if(res.data[i].families[j].cancellations[k].cancellor === 'teacher') {
                            cancellationTotal++
                        }
                    }
                }
                if (cancellationTotal > 0) {
                    list.push({
                        timesheetId: res.data[i].timesheetId,
                        timesheetDate: res.data[i].monthYear,
                        total: cancellationTotal,
                    })
                }
            }
            setListOfCancellations(list)
        })
        .catch((err) => {

        })
    }

    const toggleUploadModal = () => {
        setPhotoChange(!photoChange)
    }
    const tallyActiveStudents = () => {
        let count = 0
        for(let i = 0; i < props.teacher.Students.length; i++) {
            if(props.teacher.Students[i].Active) {
                count = count + 1
            }
        }
        return count
    }

    const changeTeacherInfo = (value, stateFunction) => {
        if(value === "leaving" || value === "Left School") {
            Axios.post(`${baseUrl}/sendteacherleavingslack`, {
                school: props.teacher.School,
                message: `:rotating_light: ${props.teacher.Name} is leaving the school! :rotating_light:`
            }, myHeader)
        }
        stateFunction(value)
        setChanges(true)
    }
    // const changeBackground = (value, stateFunction) => {
    //     changeTeacherInfo(value, stateFunction)
    //     setChanges(true)
    //    //props.changeBackgroundCheck(value)
    // }

    const clickOut = (e) => {
        if(e.target.id === "admin-teacher-modal-wrapper" || e.target.id === 'admin-modal-x') {
            if(changes) {
                setLoading(true)
                Axios.put(`${baseUrl}/updateteacherinfo`, {
                    Name: name,
                    TeacherID: props.teacher.TeacherID,
                    Password: props.teacher.Password,
                    Instrument: instruments,
                    InstrumentList: listOfInstruments,
                    TownList: listOfTowns,
                    CalendarID: calendarId,
                    Email: email.toLowerCase(),
                    ImageName: imageName,
                    PhoneNumber: phone,
                    StreetAddress: street,
                    City: city,
                    State: state,
                    Zip: zip,
                    Bio: bio,
                    Rate: rate,
                    AdminNotes: adminNotes,
                    BackgroundCheck: bkgd,
                    Status: teacherStatus,
                    Facebook: facebook,
                    Twitter: twitter,
                    Instagram: instagram,
                    Youtube: youtube,
                    Linkedin: linkedin,
                    Pinterest: pinterest,
                    Soundcloud: soundcloud,
                    Tumblr: tumblr,
                    Tiktok: tiktok,
                    Website: personalWebsite,
                    WantsMoreStudents: wantsMore,
                    OnboardDate: onboardDate,
                    DepartureDate: departureDate,
                    CalendarColor: calendarColor
                }, myHeader)
                .then(response => {
                    if(response.status === 200) {
                        setLoading(false)
                        closingAnimation()
                        setTimeout(() => {
                            props.closeModal(response.data)
                        }, 400)
                    } else {
                        alert('There was an error! Please write to Prescott...')
                    }
                })
                .catch(e => {
                    alert(e)
                })
            } else {
                closingAnimation()
                setTimeout(() => {
                    props.closeModal(props.teacher) 
                }, 400)
            }
        } else {
            return
        }
    }

    const registerChange = () => {
        setChanges(true)
    }

    const deleteTheTeacher = (theTeacherId) => {
        Axios.delete(`${baseUrl}/data/${theTeacherId}`, myHeader)
        .then(res => {
            if(res.status == 201) {
                props.removeDeletedTeacher(res.data.TeacherID)
                setDeleteModal(false)
                props.closeModal()
            }
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const openThisTimesheet = (id) => {
        for(let i = 0; i < listOfTimesheets.length; i++) {
            if(listOfTimesheets[i].timesheetId === id) {
                props.setOpenTimesheet(listOfTimesheets[i])
            }
        }
    }

    const generateWebsiteLink = async () => {
        if(props.teacher.School === 'mma') {
              await navigator.clipboard.writeText(`https://www.mountainsidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'lsma') {
              await navigator.clipboard.writeText(`https://www.lakesidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'tma') {
              await navigator.clipboard.writeText(`https://www.treesidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'mor') {
              await navigator.clipboard.writeText(`https://www.morningsidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        } else if (props.teacher.School === 'psma') {
              await navigator.clipboard.writeText(`https://www.parksidemusicacademy.com/instructors/lessons-with-${props.teacher.Name.replace(/ /g,'-').toLowerCase()}`);
              alert(`Copied ${props.teacher.Name.split(' ')[0]}'s Website Link`);
        }
    }

    return(
        <div className="admin-teacher-modal-wrapper" id="admin-teacher-modal-wrapper" onClick={(e) => clickOut(e)}>
            {deleteModal && <AreYouSureDeleteTeacherModal teacherName={name} teacher={props.teacher} setDeleteModal={setDeleteModal} deleteTheTeacher={deleteTheTeacher} />}
            {loading && <NewLoadingScreen message={'Saving Changes'}/>}
            <PhotoUpload modal={photoChange} setImg={registerChange} setImageName={(name) => setImageName(name)} toggleUploadModal={toggleUploadModal} />
            {instPopup && <AddInstrumentPopup setInstPopup={setInstPopup} listOfInstruments={listOfInstruments} setListOfInstruments={setListOfInstruments} />}
            {townsPopup && <AddTownsPopup setTownsPopup={setTownsPopup} listOfTowns={listOfTowns} setListOfTowns={setListOfTowns} school={props.teacher.School} />}
            {editTeacherAvailability && <EditTeacherAvailabilityPopup teacherAvail={teachAvail} teacherName={props.teacher.Name} email={email} setTeachAvail={setTeachAvail} setEditTeacherAvailability={setEditTeacherAvailability} />}
            <div className="admin-teacher-modal" id="admin-teacher-modal">
                <div className='admin-modal-copy-link-btn' onClick={() => generateWebsiteLink()}><svg version="1.1" id="Layer_1"  x="0px" y="0px"
	 viewBox="0 0 64 64" enable-background="new 0 0 64 64">
<g id="Text-files">
	<path d="M53.9791489,9.1429005H50.010849c-0.0826988,0-0.1562004,0.0283995-0.2331009,0.0469999V5.0228
		C49.7777481,2.253,47.4731483,0,44.6398468,0h-34.422596C7.3839517,0,5.0793519,2.253,5.0793519,5.0228v46.8432999
		c0,2.7697983,2.3045998,5.0228004,5.1378999,5.0228004h6.0367002v2.2678986C16.253952,61.8274002,18.4702511,64,21.1954517,64
		h32.783699c2.7252007,0,4.9414978-2.1725998,4.9414978-4.8432007V13.9861002
		C58.9206467,11.3155003,56.7043495,9.1429005,53.9791489,9.1429005z M7.1110516,51.8661003V5.0228
		c0-1.6487999,1.3938999-2.9909999,3.1062002-2.9909999h34.422596c1.7123032,0,3.1062012,1.3422,3.1062012,2.9909999v46.8432999
		c0,1.6487999-1.393898,2.9911003-3.1062012,2.9911003h-34.422596C8.5049515,54.8572006,7.1110516,53.5149002,7.1110516,51.8661003z
		 M56.8888474,59.1567993c0,1.550602-1.3055,2.8115005-2.9096985,2.8115005h-32.783699
		c-1.6042004,0-2.9097996-1.2608986-2.9097996-2.8115005v-2.2678986h26.3541946
		c2.8333015,0,5.1379013-2.2530022,5.1379013-5.0228004V11.1275997c0.0769005,0.0186005,0.1504021,0.0469999,0.2331009,0.0469999
		h3.9682999c1.6041985,0,2.9096985,1.2609005,2.9096985,2.8115005V59.1567993z"/>
	<path d="M38.6031494,13.2063999H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0158005
		c0,0.5615997,0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4542999,1.0158997-1.0158997
		C39.6190491,13.6606998,39.16465,13.2063999,38.6031494,13.2063999z"/>
	<path d="M38.6031494,21.3334007H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0157986
		c0,0.5615005,0.4544001,1.0159016,1.0159006,1.0159016h22.3491974c0.5615005,0,1.0158997-0.454401,1.0158997-1.0159016
		C39.6190491,21.7877007,39.16465,21.3334007,38.6031494,21.3334007z"/>
	<path d="M38.6031494,29.4603004H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
		s0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4543991,1.0158997-1.0158997
		S39.16465,29.4603004,38.6031494,29.4603004z"/>
	<path d="M28.4444485,37.5872993H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
		s0.4544001,1.0158997,1.0159006,1.0158997h12.1904964c0.5615025,0,1.0158005-0.4543991,1.0158005-1.0158997
		S29.0059509,37.5872993,28.4444485,37.5872993z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</div>
                <div className="admin-modal-x" id="admin-modal-x" onClick={(e) => clickOut(e)}>X</div>
                <img className="modal-header" src={`/${props.teacher.School.toUpperCase()}.jpg`} />
                    <div className="background-verified-wrapper">
                    </div>
                <div className='admin-teacher-modal__tab-wrapper'>
                    <div className='admin-teacher-modal__tab' style={tab === 'profile' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('profile')}>Profile</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'availability' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('availability')}>Availability</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'notes' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('notes')}>Notes</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'socials' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('socials')}>Socials</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'students' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('students')}>Students</div>
                    <div className='admin-teacher-modal__tab' style={tab === 'cancellations' ? {color: '#000', fontWeight: '900', borderBottom: '3px solid #8EAAAF'} : {color: '#888', fontWeight: '400'}} onClick={() => setTab('cancellations')}>Cancellations</div>
                </div>
                <div className="teacher-profile-box">
                    <img className="admin-modal-pic" alt={name} src={`https://app.atharo.app/images/${imageName}`} />
                    <div className="admin-modal-photo-overlay" onClick={() => setPhotoChange(true)}>
                        <h5 className="admin-modal-photo-words">Change Photo</h5>
                    </div>
                    <input className="admin-modal-teacher-name" placeholder="Teacher Name" value={name} onChange={(e) => changeTeacherInfo(e.target.value, setName) } />
                    <div className='admin-modal-onboard-date__wrapper'>
                        <input className='admin-modal-teacher-onboarding-date' type='date' value={onboardDate} onChange={(e) => changeTeacherInfo(e.target.value, setOnboardDate)} />
                    </div>
                    <h5 className="admin-teacher-modal__number-of-students">{props.teacher.newStudentList.length} Students</h5>
                    <div className='teacher-box__verified-wrapper'>
                        {bkgd === 'verified' && <img className="verified-icon" src="check.svg" />}
                        {bkgd === 'ordered' && <img className="verified-icon ordered-check" src="phone.svg" />}
                        {bkgd === 'pending' && <img className="verified-icon not-verified" src="question.svg" />}
                        <select id="the-verfied-selector" value={bkgd} onChange={(e) => changeTeacherInfo(e.target.value, setBkgd)} className="verified-selector" style={{color: verifiedColor}}>
                            <option value='verified'>Verified</option>
                            <option value='ordered'>Ordered</option>
                            <option value='pending'>Pending</option>
                        </select>
                        <select className="teacher-status-selector" value={teacherStatus} onChange={(e) => changeTeacherInfo(e.target.value, setTeacherStatus)}>
                            <option value="">Select Status</option>
                            <option value="Active">Active</option>
                            <option value="goon">Goon Mode</option>
                            <option value="leaving">Leaving</option>
                            <option value="Left School">Left School</option>
                        </select>
                    </div>
                    {teacherStatus === 'leaving' && 
                        <div className='departure-date__wrapper'>
                            <div className='departure-date__label'>Departure Date:</div>
                            <input className='admin-modal-teacher-onboarding-date' type='date' value={departureDate} onChange={(e) => changeTeacherInfo(e.target.value, setDepartureDate)} />
                        </div>
                    }
                    <div className="thin-grey-line"></div>
                    <div className='teacher-box__list-wrapper'>
                        {listOfInstruments.map((inst) => <p className='new-list-of-instruments' key={inst.id}>{inst.name}</p>)}
                    </div>
                    <div className="thin-grey-line"></div>
                    <div className='teacher-box__list-wrapper'>
                        {listOfTowns.map((town) => <p className='new-list-of-towns' key={town.id}>{town.townName}</p>)}
                    </div>
                    {listOfTowns.length > 0 && <div className="thin-grey-line"></div>}
                    <div className='admin-teacher-modal__edits-wrapper'>
                        <div className='admin-teacher-modal__edit-instruments-btn' onClick={() => setInstPopup(true)}>Edit Instruments</div>
                        <div className='admin-teacher-modal__edit-towns-btn' onClick={() => setTownsPopup(true)}>Edit Towns</div>
                    </div>
                </div>
                {tab === 'profile' &&
                    <div className='teacher-modal__new-info-box'>
                        <div className='new-info-box__spacer-div'>
                            <h5 className="for-cal-id-label">Calendar ID:</h5>
                            <input placeholder="" className="for-cal-id" placeholder="Calendar ID" value={calendarId} onChange={(e) => changeTeacherInfo(e.target.value, setCalendarId)} />
                        </div>
                        <h5 className="admin-teacher-info-label">Rate:</h5>
                        <div className="dollar-wrapper">
                            <h5 className="dollar-sign">$</h5>
                            <input className="admin-modal-teacher-rate" placeholder="Rate" value={rate} onChange={(e) => changeTeacherInfo(e.target.value, setRate) } />
                        </div>
                        <h5 className="admin-teacher-info-label">Phone:</h5>
                        <input className="basic-teacher-info-input phone-input" placeholder="Phone Number" value={phone} onChange={(e) => changeTeacherInfo(e.target.value, setPhone)} />
                        <div className='new-info-box__spacer-div'>
                            <h5 className="admin-teacher-info-label">Email:</h5>
                            <input className="basic-teacher-info-input email-input" placeholder="Email" value={email} onChange={(e) => changeTeacherInfo(e.target.value, setEmail)} />
                        </div>
                        <div className="thin-grey-line-"></div>
                        <div className='new-info-box__spacer-div'>
                            <div className="admin-availability-title">Address:</div>
                            <input className="basic-teacher-info-input add-inline for-street" placeholder="Street Address" value={street} onChange={(e) => changeTeacherInfo(e.target.value, setStreet)} />
                            <div>
                                <input className="basic-teacher-info-input add-inline for-city" placeholder="City" value={city} onChange={(e) => changeTeacherInfo(e.target.value, setCity)} />
                                <input className="basic-teacher-info-input add-inline for-state" placeholder="State" value={state} onChange={(e) => changeTeacherInfo(e.target.value, setAddressState)} />
                                <input className="basic-teacher-info-input add-inline for-zip" placeholder="ZIP" value={zip} onChange={(e) => changeTeacherInfo(e.target.value, setZip)} />
                            </div>
                        </div>
                        <h5 className="bio-label">Bio:</h5>
                        <textarea className="for-bio" placeholder="Bio" value={bio} onChange={(e) => changeTeacherInfo(e.target.value, setBio)} />
                    </div>
                }
                {tab === 'availability' &&
                    <div className='teacher-modal__new-info-box'>
                        <div>
                            <div style={wantsMore ? {opacity: 1} : {opacity: 0.2}}>
                                <Availabilities wholeAvail={teachAvail} />
                            </div>
                            <div className='admin-availability__edit-teachers-availability__wrapper'>
                                <div style={wantsMore ? {opacity: 1} : {opacity: 0.2}} className='admin-availability__edit-teachers-availability' onClick={wantsMore ? () => setEditTeacherAvailability(true) : null}>Edit Availability</div>
                                <div className="teacher-modal__full-schedule-switch__wrapper">
                                {!wantsMore && <svg className="new-teacher-portal__switch-svg" viewBox="0 0 511.999 511.999" onClick={() => changeTeacherInfo(true, setWantsMore)}>
                                    <g>
                                    	<g>
                                    		<path fill="rgb(255, 100, 100)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                    			S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                    			c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                    	</g>
                                    </g>
                                </svg>}
                                {wantsMore && <svg className="new-teacher-portal__switch-svg" viewBox="0 0 512 512" onClick={() => changeTeacherInfo(false, setWantsMore)}>
                                    <g>
                                    	<g>
                                    		<path fill="rgba(0, 128, 0, 0.8)" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                    			S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                    			c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                    	</g>
                                    </g>
                                </svg>}
                                {wantsMore ? <h5>Wants More Students</h5> : <h5>FULL!</h5>}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {tab === 'notes' &&
                    <div className='teacher-modal__new-info-box'>
                        <div className="teacher-notes"><strong>Teacher's Notes:</strong> {props.teacher.Notes}</div>
                        <h5 className="for-notes-admin-label">Admin Notes (Only Visible to Admins):</h5>
                        <textarea className="for-notes-admin" value={adminNotes} onChange={(e) => changeTeacherInfo(e.target.value, setAdminNotes)} />
                    </div>
                }
                {tab === 'socials' &&
                    <div className='teacher-modal__new-info-box'>
                        <div className="teacher-social-links">
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Facebook</h5>
                                <input className='teacher-social-links__input' value={facebook} placeholder="Teacher's Facebook" onChange={(e) => changeTeacherInfo(e.target.value, setFacebook)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Twitter</h5>
                                <input className='teacher-social-links__input' value={twitter} placeholder="Teacher's Twitter" onChange={(e) => changeTeacherInfo(e.target.value, setTwitter)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Instagram</h5>
                                <input className='teacher-social-links__input' value={instagram} placeholder="Teacher's Instagram" onChange={(e) => changeTeacherInfo(e.target.value, setInstagram)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Youtube</h5>
                                <input className='teacher-social-links__input' value={youtube} placeholder="Teacher's Youtube" onChange={(e) => changeTeacherInfo(e.target.value, setYoutube)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>LinkedIn</h5>
                                <input className='teacher-social-links__input' value={linkedin} placeholder="Teacher's LinkedIn" onChange={(e) => changeTeacherInfo(e.target.value, setLinkedin)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Pinterest</h5>
                                <input className='teacher-social-links__input' value={pinterest} placeholder="Teacher's Pinterest" onChange={(e) => changeTeacherInfo(e.target.value, setPinterest)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Soundcloud</h5>
                                <input className='teacher-social-links__input' value={soundcloud} placeholder="Teacher's SoundCloud" onChange={(e) => changeTeacherInfo(e.target.value, setSoundcloud)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Tumblr</h5>
                                <input className='teacher-social-links__input' value={tumblr} placeholder="Teacher's Tumblr" onChange={(e) => changeTeacherInfo(e.target.value, setTumblr)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Tiktok</h5>
                                <input className='teacher-social-links__input' value={tiktok} placeholder="Teacher's Tiktok" onChange={(e) => changeTeacherInfo(e.target.value, setTiktok)}/>
                            </div>
                            <div className='teacher-social-links__wrapper'>
                                <h5 className='teacher-social-links__label'>Personal Website</h5>
                                <input className='teacher-social-links__input' value={personalWebsite} placeholder="Teacher's Website" onChange={(e) => changeTeacherInfo(e.target.value, setPersonalWebsite)}/>
                            </div>
                        </div>
                    </div>
                }
                {tab === 'students' &&
                    <div className='teacher-modal__new-info-box'>
                        <div className="current-student-list">
                            <h4>Current Students</h4>
                            {props.teacher.newStudentList.map((student) => (
                                <h4 className="current-student-name" key={student.studentId} onClick={() => props.getFamilyData(student.familyId)}>{student.firstName} {student.lastName}</h4>
                            ))}
                        </div>
                    </div>
                }
                {tab === 'cancellations' &&
                    <div className='teacher-modal__new-info-box'>
                        {
                            listOfCancellations.length > 0 ?
                            listOfCancellations.map((cancellation) => cancellation.total > 0 && (
                                <div className='teacher-modal__cancellation-wrapper' key={cancellation.timesheetDate} onClick={() => openThisTimesheet(cancellation.timesheetId)}>
                                    <div className='teacher-modal__cancelltaion-wrapper__date'>{cancellation.timesheetDate}:</div>
                                    <div className='teacher-modal__cancelltaion-wrapper__number'>{cancellation.total} Cancellation</div>
                                    <div className='teacher-modal__cancelltaion-wrapper__click'>View Timesheet</div>
                                </div>
                            ))
                        :
                            <div>No Cancellations</div>
                        }
                    </div>
                }
                <div className="delete-teacher-btn" onClick={() => setDeleteModal(true)}>Delete Teacher</div>
            </div>
        </div>
    )
}

export default AdminTeacherModal